import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AuftragCustomerDetailComponent from '../../component/AuftragCustomerDetailComponent/AuftragCustomerDetailComponent';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';

/**
 * @author noone
 */
export default function EigeneAuftraegeDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { uid } = useParams<{ uid: string }>();

  const onSpeichern = () => {
    navigate({
      pathname: "/",
      search: ""
    })
  }

  return (
    <>
      <LandingpageHeader />

      <div style={{ marginLeft: "3em", marginRight: "3em" }} key={location.pathname} >

        <div>

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

        </div>

        {uid &&
          <>
            <h3>{t('deTranslation.auftragDetails.titel')}</h3>

            {uid &&
              <AuftragCustomerDetailComponent uid={uid} onSpeichern={onSpeichern} />
            }

          </>}

        <Footer />
      </div>
    </>
  );

}


